import axios from "axios";

import { API_BASE_URL } from "./config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL, // Set your API base URL
});

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Date.now() >= payload.exp * 1000;
  } catch {
    return false;
  }
};

const handleLogout = () => {
  localStorage.removeItem("homeshiksha-tutor-jwt");
  window.location.href = "/";
  window.location.reload();
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("homeshiksha-tutor-jwt")); // Retrieve your JWT token
    if (token) {
      if (isTokenExpired(token)) {
        handleLogout();
        return Promise.reject(new Error("Token expired"));
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      handleLogout();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
